import React from 'react'
import TestRunList from './components/testRun/list/TestRunList'

const TestRunMain = () => {
    return (
        <div>
            <div
                className="container"
                style={{
                    zIndex: 10,
                    minHeight: '100vh',
                    padding: '35px',
                    borderRadius: '0px',
                }}
            >
                <TestRunList />
            </div>
        </div>
    )
}

export default TestRunMain
